import { render, staticRenderFns } from "./ResultsNav.vue?vue&type=template&id=4442c151&"
import script from "./ResultsNav.vue?vue&type=script&lang=js&"
export * from "./ResultsNav.vue?vue&type=script&lang=js&"
import style0 from "./ResultsNav.vue?vue&type=style&index=0&id=4442c151&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports